/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImportAenderung } from './ImportAenderung';
import {
    ImportAenderungFromJSON,
    ImportAenderungFromJSONTyped,
    ImportAenderungToJSON,
} from './ImportAenderung';
import type { RvcImport } from './RvcImport';
import {
    RvcImportFromJSON,
    RvcImportFromJSONTyped,
    RvcImportToJSON,
} from './RvcImport';

/**
 * 
 * @export
 * @interface RvcImportAntwort
 */
export interface RvcImportAntwort {
    /**
     * 
     * @type {Array<ImportAenderung>}
     * @memberof RvcImportAntwort
     */
    importAenderungen: Array<ImportAenderung>;
    /**
     * 
     * @type {RvcImport}
     * @memberof RvcImportAntwort
     */
    rvcImport: RvcImport;
    /**
     * 
     * @type {string}
     * @memberof RvcImportAntwort
     */
    machineGroups: string;
    /**
     * 
     * @type {string}
     * @memberof RvcImportAntwort
     */
    rvcImportInformation?: string;
}

/**
 * Check if a given object implements the RvcImportAntwort interface.
 */
export function instanceOfRvcImportAntwort(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "importAenderungen" in value;
    isInstance = isInstance && "rvcImport" in value;
    isInstance = isInstance && "machineGroups" in value;

    return isInstance;
}

export function RvcImportAntwortFromJSON(json: any): RvcImportAntwort {
    return RvcImportAntwortFromJSONTyped(json, false);
}

export function RvcImportAntwortFromJSONTyped(json: any, ignoreDiscriminator: boolean): RvcImportAntwort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'importAenderungen': ((json['importAenderungen'] as Array<any>).map(ImportAenderungFromJSON)),
        'rvcImport': RvcImportFromJSON(json['rvcImport']),
        'machineGroups': json['machineGroups'],
        'rvcImportInformation': !exists(json, 'rvcImportInformation') ? undefined : json['rvcImportInformation'],
    };
}

export function RvcImportAntwortToJSON(value?: RvcImportAntwort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'importAenderungen': ((value.importAenderungen as Array<any>).map(ImportAenderungToJSON)),
        'rvcImport': RvcImportToJSON(value.rvcImport),
        'machineGroups': value.machineGroups,
        'rvcImportInformation': value.rvcImportInformation,
    };
}

